import {ICheckInRestriction} from "./check-in-restriction.interface";
import {IServiceFactory} from "../../../service-factory.interface";

export class StandByOnlineCheckInRestriction implements ICheckInRestriction {
    constructor(private readonly services: IServiceFactory) {
    }

    get description(): string {
        return this.services.language.translate('Online check-in is not available for standby flights. Please check in at the airport.');
    }

    get shouldBlockSavingTravelDocuments(): boolean {
        return false;
    }
}
